import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=5c5a3186&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=5c5a3186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a3186",
  null
  
)

export default component.exports